import { render, staticRenderFns } from "./form2.vue?vue&type=template&id=0cab9a3f&scoped=true&"
import script from "./form2.vue?vue&type=script&lang=js&"
export * from "./form2.vue?vue&type=script&lang=js&"
import style0 from "./form2.vue?vue&type=style&index=0&id=0cab9a3f&prod&lang=css&"
import style1 from "./form.css?vue&type=style&index=1&id=0cab9a3f&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0cab9a3f",
  null
  
)

export default component.exports